import PropTypes from 'prop-types';
import { forwardRef, useState, useRef, useImperativeHandle, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import styles from './FJTextAreaWithLyric.module.less';
import InspireIcon from '../../../assets/svg/inspire-me.svg?react';
import FJTutorialIcon from '../../../assets/svg/tutorial.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJButton from '../../components/FJButton/FJButton.jsx';
import FJUtil from '../../../util/FJUtil.js';

const FJTextAreaWithLyric = forwardRef((props, ref) => {
    const {
        text,
        onBlur,
        disabled,
        maxLength,
        onChange,
        onKeyDown,
        readOnly,
        placeholder = 'Describe the image you want to generate',
        className,
        inputClassName,
        onFocus,
        onDescChange,
        descText,

        generateLyrics,
        isGenerateLyricsLoading,
    } = props;

    const [stateText, setStateText] = useState(text || '');
    const [stateDescText, setStateDescText] = useState(descText || '');
    const inputRef = useRef(null);
    const [isFocused, setIsFocused] = useState(false);
    const textareaRef = useRef(null);

    useImperativeHandle(ref, () => ({
        focus: () => {
            if (textareaRef.current) {
                textareaRef.current.focus();
            }
        },
        setText: text => {
            setStateText(text);
        },
        getTextarea: () => {
            return textareaRef.current;
        },
    }));

    useEffect(() => {
        inputRef.current.value = descText;
    }, []);

    // useEffect(() => {
    //     setStateDescText(descText);
    // }, [descText]);

    useEffect(() => {
        setStateText(text);
    }, [text]);

    const _onBlur = e => {
        setIsFocused(false);
        if (onBlur) {
            onBlur(e);
        }
    };

    const _onFocus = e => {
        setIsFocused(true);
        if (onFocus) {
            onFocus(e);
        }
    };

    const _onKeyDown = useCallback(
        e => {
            if ((e.ctrlKey || e.metaKey) && e.keyCode === 65) {
                const value = textareaRef.current.value;
                textareaRef.current.value = '';
                textareaRef.current.value = value;
                textareaRef.current.select();
            }

            if (onKeyDown) {
                onKeyDown(e);
            }
        },
        [textareaRef, onKeyDown],
    );

    const _onChange = e => {
        let value = e.target.value;
        value = FJUtil.sliceByteLen(value, 350);
        if (value !== e.target.value) {
            textareaRef.current.value = value;
        }
        setStateText(value);
        if (onChange) {
            onChange(value);
        }
    };

    const _onDescChange = e => {
        // setStateDescText(e.target.value);
        if (onDescChange) {
            onDescChange(e.target.value);
        }
    };

    const _onForbidDrag = e => {
        e.preventDefault();
        e.stopPropagation();
        return;
    };

    const _toGuide = () => {
        window.open(
            'https://help.flexclip.com/en/articles/10326783-how-to-write-effective-text-prompts-to-generate-ai-videos',
        );
    };

    const cnPanel = classNames(
        styles.textarea_box,
        isFocused ? styles.textarea_focus : '',
        disabled ? styles.textarea_disabled : '',
        className,
    );

    return (
        <div className={cnPanel}>
            <textarea
                className={classNames(styles.content_textarea, inputClassName)}
                ref={textareaRef}
                readOnly={readOnly}
                value={stateText}
                placeholder={placeholder}
                onBlur={_onBlur}
                onKeyDown={_onKeyDown}
                onChange={_onChange}
                onFocus={_onFocus}
                maxLength={maxLength}
                disabled={disabled}
                onDragStart={_onForbidDrag}
            />
            <div className={styles.bottom_box}>
                <input
                    className={styles.input}
                    type='text'
                    placeholder={FJLocalStore._('describe-the-lyrics')}
                    onDragStart={_onForbidDrag}
                    // value={stateDescText}
                    onChange={_onDescChange}
                    maxLength={400}
                    ref={inputRef}
                />
                <FJButton
                    className={styles.btn}
                    type='gradient'
                    text='generate'
                    onClick={generateLyrics}
                    isLoading={isGenerateLyricsLoading}
                    loadingStyle={{ width: 16, height: 16 }}
                />
            </div>
        </div>
    );
});

FJTextAreaWithLyric.displayName = 'FJTextAreaWidthInspire';

FJTextAreaWithLyric.propTypes = {
    generateLyrics: PropTypes.func,
    isGenerateLyricsLoading: PropTypes.bool,
    text: PropTypes.string,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    readOnly: PropTypes.bool,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    onFocus: PropTypes.func,
};

export default FJTextAreaWithLyric;
